(() => {
  const SWATCH_SELECTOR = '.swatch-color[data-variant-url]';
  const CARD_SELECTOR = '.product-card';
  const IMAGE_LINK_SELECTOR = '[data-product-card-link]';
  const MAIN_IMAGE_CONTAINER_SELECTOR = '.product-card__image--main';
  const IMAGE_WRAPPER_SELECTOR = '.product-card__image-wrapper';
  const VARIANT_DATA_SELECTOR = '[data-product-card-variant-data]';

  const containsMatch = (source, target) => {
    if (!source || !target) return false;
    const a = String(source).toLowerCase().trim();
    const b = String(target).toLowerCase().trim();
    if (!a || !b) return false;
    return a.includes(b) || b.includes(a);
  };

  const getVariantData = (card) => {
    const dataEl = card.querySelector(VARIANT_DATA_SELECTOR);
    if (!dataEl) return null;

    try {
      return JSON.parse(dataEl.textContent);
    } catch (error) {
      return null;
    }
  };

  const findMatchInVariantData = (variantData, swatchValue) => {
    if (!variantData || !swatchValue) return null;

    let fallbackVariant = null;

    for (const variant of variantData.variants || []) {
      const options = variant.options || [];
      const matches = options.some((option) => containsMatch(option, swatchValue));
      if (!matches) continue;

      if (variant.image) {
        return {
          url: variant.url,
          image: variant.image,
          srcset: variant.srcset || '',
        };
      }

      if (!fallbackVariant) {
        fallbackVariant = variant;
      }
    }

    if (fallbackVariant) {
      return {
        url: fallbackVariant.url,
        image: fallbackVariant.image || '',
        srcset: fallbackVariant.srcset || '',
      };
    }

    for (const image of variantData.images || []) {
      if (containsMatch(image.alt, swatchValue) && image.image) {
        return {
          url: '',
          image: image.image,
          srcset: image.srcset || '',
        };
      }
    }

    return null;
  };

  const getSwatchValue = (swatch) => swatch.dataset.swatchValue || swatch.getAttribute('title') || '';

  const getVariantImage = (card, swatch) => {
    const swatchValue = getSwatchValue(swatch);
    const variantData = getVariantData(card);
    const matched = findMatchInVariantData(variantData, swatchValue);

    if (matched?.image) {
      return {
        src: matched.image,
        srcset: matched.srcset,
        url: matched.url,
      };
    }

    if (swatch.dataset.variantImage) {
      return {
        src: swatch.dataset.variantImage,
        srcset: swatch.dataset.variantImageSrcset || '',
        url: swatch.dataset.variantUrl || '',
      };
    }

    const bgImage = getComputedStyle(swatch).backgroundImage;
    const match = bgImage && bgImage.match(/url\((['"]?)(.+?)\1\)/);
    if (match && match[2] && !match[2].startsWith('data:')) {
      return {
        src: match[2],
        srcset: '',
        url: swatch.dataset.variantUrl || '',
      };
    }

    return null;
  };

  const updateActiveSwatch = (card, activeSwatch) => {
    card.querySelectorAll(SWATCH_SELECTOR).forEach((swatch) => {
      const isActive = swatch === activeSwatch;
      swatch.classList.toggle('is-active', isActive);
      swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const updateProductImage = (card, swatch, imageData) => {
    if (!imageData?.src) return;

    const mainImageContainer = card.querySelector(MAIN_IMAGE_CONTAINER_SELECTOR);
    const currentImage = mainImageContainer?.querySelector('img');
    if (!mainImageContainer || !currentImage) return;

    const newImage = document.createElement('img');
    newImage.alt = currentImage.alt || '';
    newImage.className = currentImage.className;
    newImage.sizes = currentImage.sizes || '';
    newImage.loading = 'eager';
    newImage.decoding = 'async';
    newImage.src = imageData.src;

    if (imageData.srcset) {
      newImage.srcset = imageData.srcset;
    }

    currentImage.replaceWith(newImage);

    const picture = newImage.closest('picture');
    if (picture) {
      picture.classList.add('swatch-switched');
    }

    const mediaWrapper = newImage.closest('.media-wrapper');
    if (mediaWrapper) {
      mediaWrapper.classList.remove('loading');
      mediaWrapper.classList.add('loaded');
    }

    const imageWrapper = card.querySelector(IMAGE_WRAPPER_SELECTOR);
    if (imageWrapper) {
      imageWrapper.classList.add('swatch-selected');
    }
  };

  const updateProductLink = (card, swatch, imageData) => {
    const imageLink = card.querySelector(IMAGE_LINK_SELECTOR);
    if (!imageLink) return;

    const url = imageData?.url || swatch.dataset.variantUrl;
    if (url) {
      imageLink.href = url;
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest(SWATCH_SELECTOR);
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();

      const card = swatch.closest(CARD_SELECTOR);
      if (!card) return;

      const imageData = getVariantImage(card, swatch);
      updateProductImage(card, swatch, imageData);
      updateProductLink(card, swatch, imageData);
      updateActiveSwatch(card, swatch);
    },
    true
  );
})();
